
import React from "react";
import { motion } from "framer-motion";
import { Star } from "lucide-react";

const translations = {
  en: {
    title: "Student Success Stories",
    subtitle: "Hear from Our Students",
    testimonials: [
      {
        name: "Ilhan Shuaib",
        program: "Master of Cybersecurity, UTM",
        text: "The Horn Educational Network made my dream of studying cybersecurity a reality. Their guidance and support throughout the application process was invaluable.",
        rating: 5,
        image: "https://storage.googleapis.com/hostinger-horizons-assets-prod/2035fa37-35aa-4837-b61a-e7175478d8be/48a5b45e5411798e5440d1b3a6e2d593.png"
      },
      {
        name: "Abdullahi Hassan",
        program: "Bachelor of Medicine & Bachelor of Surgery (MBBS), University of Cyberjaya",
        text: "Thanks to The Horn Educational Network, I'm now pursuing my medical degree in Malaysia. Their team helped me navigate every step of the journey.",
        rating: 5,
        image: "https://storage.googleapis.com/hostinger-horizons-assets-prod/2035fa37-35aa-4837-b61a-e7175478d8be/81d47cf6292ad5f305c4ba56e4c8e2fb.png"
      },
      {
        name: "Salman Omar",
        program: "Bachelor of Software Engineering, Multimedia University",
        text: "The team's expertise in Malaysian universities helped me find the perfect program. Their scholarship guidance was particularly helpful.",
        rating: 5,
        image: "https://storage.googleapis.com/hostinger-horizons-assets-prod/2035fa37-35aa-4837-b61a-e7175478d8be/8b23db73183f3a85024df88f337a70a2.jpg"
      },
      {
        name: "Mohamed Osman",
        program: "Bachelor of Architecture, City University Malaysia",
        text: "Studying architecture in Malaysia has been an amazing experience. The Horn Educational Network's support made it all possible.",
        rating: 5,
        image: "https://storage.googleapis.com/hostinger-horizons-assets-prod/2035fa37-35aa-4837-b61a-e7175478d8be/15514b9aa8b14027773048c2b9e61644.webp"
      }
    ]
  },
  // ... other translations remain the same
};

function Testimonials({ language }) {
  const content = translations[language];

  return (
    <section className="py-20 bg-primary/5">
      <div className="container mx-auto px-4">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-12"
        >
          <h2 className="text-3xl md:text-4xl font-bold mb-4">{content.title}</h2>
          <p className="text-lg text-muted-foreground">{content.subtitle}</p>
        </motion.div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
          {content.testimonials.map((testimonial, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: index * 0.1 }}
              className="bg-background rounded-lg overflow-hidden shadow-lg"
            >
              <div className="relative h-48 overflow-hidden">
                <img
                  src={testimonial.image}
                  alt={testimonial.name}
                  className="w-full h-full object-cover transform hover:scale-110 transition-transform duration-500"
                />
              </div>
              <div className="p-6">
                <div className="flex gap-1 mb-4">
                  {[...Array(testimonial.rating)].map((_, i) => (
                    <Star key={i} className="w-5 h-5 fill-accent text-accent" />
                  ))}
                </div>
                <p className="text-muted-foreground mb-4">{testimonial.text}</p>
                <div>
                  <p className="font-semibold">{testimonial.name}</p>
                  <p className="text-sm text-muted-foreground">{testimonial.program}</p>
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Testimonials;
